module.exports = __webpack_public_path__ + "static/media/referral-en.792f2fee.png";